import React, { Component } from 'react';
import { View, Image, Text, TouchableOpacity } from 'react-native';
import { inject, observer } from 'mobx-react/native';
import styles from './style';
import { RootStoreInterface } from '../../../Store/index';
import { EmptyStatus } from '@qnpm/q-components';
import { NoDataTypes } from '../NoDataTypes';

interface Props {
    showNoData?: boolean;
    type?: NoDataTypes;
    isLogin?: boolean; // 暂时用不到，当作调试用吧
    noDataFlag?: boolean; // 暂时用不到，当作调试用吧

    onPressLogin(): void;
    onPressRedo(): void;
}

@inject((store: RootStoreInterface) => ({
    showNoData: store.orderlist.showNoData,
    isLogin: store.orderlist.isLogin,
    noDataFlag: store.orderlist.noDataFlag,
    type: store.orderlist.type,
}))
@observer
class NoData extends Component<Props> {
    public onPressLogin = () => {
        const { onPressLogin } = this.props;
        if (onPressLogin) {
            onPressLogin();
        }
    };

    public onPressRedo = () => {
        const { onPressRedo } = this.props;
        if (onPressRedo) {
            onPressRedo?.();
        }
    };

    public render() {
        const { showNoData, type } = this.props;
        if (!showNoData || type === 'none') {
            return null;
        }
        /*
         * type 注释看NoDataTypes.ts 文件
         */
        let emptyStatusView = null;
        switch (type) {
            case 'loginInvalid':
                emptyStatusView =  (
                    <EmptyStatus
                        type={'emptyData'}
                        text={(<View>
                                <Text style={styles.noLoginTitle}>不好，登录失效了，重新登录吧</Text>
                            </View>
                        )}
                        buttonText={"登录"}
                        showButton={true}
                        onPress={() => {this.onPressLogin()}}
                        needScale
                    />
                )
                break;
            case 'noLoginAndNoLocalOrder':
                emptyStatusView =  (
                    <EmptyStatus
                        type={'emptyData'}
                        text={(<View>
                                <Text style={styles.noLoginTitle}>您还没有本地订单呦</Text>
                                <Text style={styles.noLoginTitle}>快速登录查看在线订单吧~</Text>
                            </View>
                        )}
                        buttonText={"登录"}
                        showButton={true}
                        onPress={() => {this.onPressLogin()}}
                        needScale
                    />
                )
                break;
            case 'loginedNoOrder':
                emptyStatusView =  (
                    <EmptyStatus
                        type={'emptyData'}
                        text={"您还没有订单呦～"}
                        needScale
                    />
                )
                break;
            case 'loginedNoOrderWithTrain':
                emptyStatusView =  (
                    <EmptyStatus
                        type={'emptyData'}
                        text={"您还没有订单呦～"}
                        needScale
                    />
                )
                break;
            case 'networkFail':
                emptyStatusView =  (
                    <EmptyStatus
                        type={'netError'}
                        onPress={() => {this.onPressRedo()}}
                        needScale
                    />
                )
                break;
            case 'dataLoadFail':
                emptyStatusView =  (
                    <EmptyStatus
                        type={'noData'}
                        onPress={() => {this.onPressRedo()}}
                        needScale
                    />
                )
                break;
            default:
                emptyStatusView = null;
                break;
        }

        return (
            <View style={styles.noDataWrapper}>
                <View style={styles.noDataContent} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.BTN_LOGIN_1)}>
                    {
                        emptyStatusView
                    }
                </View>
            </View>
        );
    }
}

export default NoData;
